import React from 'react';
import LocationSearch from '../LocationSearch';

const Header = ({ onSearch, city, temperatureUnit, onSetTemperatureUnit }) => {
  return (
    <header className="flex items-center justify-end px-4 lg:px-8 py-6 gap-6">
        <LocationSearch getWeather={onSearch} compact={true} />
        <div className="flex items-center gap-2 bg-white/70 backdrop-blur-sm rounded-lg p-1" role="group" aria-label="Temperature unit">
          <button
            type="button"
            onClick={() => onSetTemperatureUnit?.('celsius')}
            aria-pressed={temperatureUnit === 'celsius'}
            className={`px-4 py-3 rounded-md text-sm font-medium transition-all ${
              temperatureUnit === 'celsius'
                ? 'bg-gray-800 text-white'
                : 'text-gray-600 hover:text-gray-800'
            }`}
          >
            °C
          </button>
          <button
            type="button"
            onClick={() => onSetTemperatureUnit?.('fahrenheit')}
            aria-pressed={temperatureUnit === 'fahrenheit'}
            className={`px-4 py-3 rounded-md text-sm font-medium transition-all ${
              temperatureUnit === 'fahrenheit'
                ? 'bg-gray-800 text-white'
                : 'text-gray-600 hover:text-gray-800'
            }`}
          >
            °F
          </button>
        </div>
    </header>
  );
};

export default Header;

